import { render, staticRenderFns } from "./RaceAdvanceSetting.vue?vue&type=template&id=386a95e2&scoped=true&"
import script from "./RaceAdvanceSetting.vue?vue&type=script&lang=js&"
export * from "./RaceAdvanceSetting.vue?vue&type=script&lang=js&"
import style0 from "./RaceAdvanceSetting.vue?vue&type=style&index=0&id=386a95e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a95e2",
  null
  
)

export default component.exports